import React from "react";
import { Routes, Route } from "react-router-dom";
import EditContactUs from "./edit-contact-us";
import ContactUsDetail from "./contact-us-detail";

//
const ContactUs = () => {
  return (
    <React.Fragment>
      <Routes>
        <Route path="" element={<ContactUsDetail />} />
         <Route path="/" element={<ContactUsDetail />} />
         <Route path="/edit" element={<EditContactUs />} />
      </Routes>
    </React.Fragment>
  );
};

export default ContactUs;
